const amountToK = (amount: number): string => {
    if (amount < 1000) {
        return `${amount}`;
    }

    const isBillion = amount >= 1000000;
    const suffix = isBillion ? 'M' : 'K';
    const divisor = isBillion ? 1000000 : 1000;
    const formattedAmount = Math.floor((amount / divisor) * 100) / 100;

    return `${formattedAmount}${suffix}`;
};

export default amountToK;
